import React from 'react';

const TrustExperience = () => {
  return (
    <section className="section dark" id="trust-experience">
      <h2 className="section-title">Proven Expertise. Trusted Results.</h2>
      <p className="section-subtitle" style={{ color: '#fff' }}>
        Over 33 years of research and development in combustion optimisation.
      </p>
      <div className="cards">
        <div className="card" style={{ backgroundColor: 'rgba(255,255,255,0.1)', color: '#fff' }}>
          <h3>33+ Years Experience</h3>
          <p>
            MICRO 24 is built on more than three decades of expertise in fuel
            additives and combustion technology. Formerly known as MICROEX,
            our formulation has stood the test of time.
          </p>
        </div>
        <div className="card" style={{ backgroundColor: 'rgba(255,255,255,0.1)', color: '#fff' }}>
          <h3>Developed by Experts</h3>
          <p>
            A dedicated R&D team continuously refines the formula to deliver
            instant and consistent results across a range of industrial
            applications.
          </p>
        </div>
        <div className="card" style={{ backgroundColor: 'rgba(255,255,255,0.1)', color: '#fff' }}>
          <h3>Trusted by Industry</h3>
          <p>
            Used by corporates, forging industries, government organisations,
            dairies and SMEs to improve efficiency and reduce emissions.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TrustExperience;